/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Delete_Confirm_TitleInputs */

const he_notifications_delete_confirm_title = /** @type {(inputs: Notifications_Delete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`האם אתה בטוח?`)
};

const en_notifications_delete_confirm_title = /** @type {(inputs: Notifications_Delete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure?`)
};

/**
* | output |
* | --- |
* | "Are you sure?" |
*
* @param {Notifications_Delete_Confirm_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_delete_confirm_title = /** @type {((inputs?: Notifications_Delete_Confirm_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Delete_Confirm_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_delete_confirm_title(inputs)
	return en_notifications_delete_confirm_title(inputs)
});